import { HttpClient } from '@opallabs/api'
import loadWorkflow from '../loadWorkflow'

const typer = (type, identifier) =>
  type && identifier ? `${type}/${identifier}/` : ''

const putResendApproval = ({
  identifier,
  resendToDenied,
  type,
  workflowId,
  phaseId,
}) =>
  HttpClient().put(
    `/api/v1/${typer(
      type,
      identifier
    )}workflow/${workflowId}/phases/${phaseId}/resend`,
    {
      data: {
        resendToDenied,
      },
    }
  )

const resendApprovals =
  ({ identifier, phaseId, resendToDenied, type, workflowId }) =>
  (dispatch) =>
    putResendApproval({
      identifier,
      resendToDenied,
      type,
      workflowId,
      phaseId,
    })
      .then((response) => dispatch(loadWorkflow(response.data)))
      .catch((err) => {
        console.log(err)
        throw err
      })

export default resendApprovals
